import React from "react";
import clsx from "clsx";
import { MODE_LABELS } from "../ReservationConfigForm";

/** Multi-select chip list */
export default function ModeSelector({ value = [], onChange }) {
  /** Toggle helper ---------------------------------------------------- */
  const toggle = (m) =>
    onChange(value.includes(m) ? value.filter((x) => x !== m) : [...value, m]);

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
      {Object.keys(MODE_LABELS).map((m) => (
        <button
          key={m}
          type="button"
          onClick={() => toggle(m)}
          className={clsx(
            "rounded-lg px-3 py-2 text-sm transition",
            value.includes(m)
              ? "bg-blue-600 text-white shadow"
              : "bg-white text-gray-700 hover:ring"
          )}
        >
          {MODE_LABELS[m]}
        </button>
      ))}
    </div>
  );
}
